module.exports = __webpack_public_path__ + "static/media/app-bar-account.07b949ee.svg";